import Action from 'redux/helpers/createAction'
const name = 'keywordMetrics'

export const exportDomainKeywordMetricsExcel = Action(
  name + '/EXPORT_DOMAIN_KEYWORD_METRICS_DATA_EXCEL',
  domainId => ({
    domainId
  })
)

export const exportDomainKeywordMetricsCSV = Action(
  name + '/EXPORT_DOMAIN_KEYWORD_METRICS_DATA_CSV',
  domainId => ({
    domainId
  })
)
